import React, { Component } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import AuthService from "../services/auth.service";
import {Navigate} from "react-router-dom";
import OdooService from "../services/odoo.service";
import authService from "../services/auth.service";

const required = value => {
    if (!value) {
        return (
            <div className="alert alert-danger" role="alert">
                Champ obligatoire.
            </div>
        );
    }
};
const userConnect = AuthService.getCurrentUser();
const vucm = value => {
    if(userConnect.service==="Tous") {
        if (value[0] + value[1] + value[2] !== "CM-" && value[0] + value[1] + value[2] !== "PM-" && value[0] + value[1] + value[2] !== "MB-" && value[0] + value[1] + value[2] !== "B2B") {
            return (
                <div className="alert alert-danger" role="alert">
                    La référence client commence par CM ou PM ou MB ou B2B.
                </div>
            );
        }
    }else if(userConnect.service==="B2C"){
        if (value[0] + value[1] + value[2] !== "CM-" && value[0] + value[1] + value[2] !== "PM-") {
            return (
                <div className="alert alert-danger" role="alert">
                    La référence client commence par CM ou PM.
                </div>
            );
        }
    }else{
        if (value[0] + value[1] + value[2] !== "MB-" && value[0] + value[1] + value[2] !== "B2B") {
            return (
                <div className="alert alert-danger" role="alert">
                    La référence client commence par MB ou B2B.
                </div>
            );
        }
    }
};


export default class CreatePayment extends Component {
    constructor(props) {
        super(props);
        this.handleAction = this.handleAction.bind(this);
        this.onChangeCm = this.onChangeCm.bind(this);
        this.handleOptionChangeOrigine = this.handleOptionChangeOrigine.bind(this);

        this.state = {
            cm: "",
            redirect:"",
            nextPage:"",
            loading:false,
            currentUser:"",
            roleConnect:""
        };
    }

    onChangeCm(e) {
        this.setState({
            cm: e.target.value
        });
    }

    handleOptionChangeOrigine(index){
        localStorage.setItem("origine", index.target.value);
    }
    handleAction(e) {
        e.preventDefault();
        this.setState({
            message: "",
            successful: false,
            loading:true
        });

        this.form.validateAll();
        localStorage.removeItem("contracts");
        localStorage.removeItem("contract");
        localStorage.removeItem("customer");
        if (this.checkBtn.context._errors.length === 0) {
            OdooService.getContractsCustomer(this.state.cm).then(
                response => {
                    if(!response.error) {
                        this.setState({
                            successful: true,
                            nextPage: "/info_payment",
                            loading: false
                        });
                    }else{
                        this.setState({
                            loading: false,
                            message: response.error
                        });
                    }
                },
                error => {
                    const resMessage =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    this.setState({
                        loading: false,
                        message: resMessage
                    });
                }
            );
        }else{
            this.setState({loading:false});
        }
    }
    componentDidMount() {
        const currentUser = AuthService.getCurrentUser();
        if (!currentUser) {
            authService.logout();
        }
        this.setState({ currentUser: currentUser, userReady: true, roleConnect: currentUser.roles[0] })
        if(localStorage.getItem("origine")==="") {
            if ((currentUser.roles[0] !== "ROLE_AGENT_EXTERN" || currentUser.roles[0] !== "ROLE_SUPER_AGENT_EXTERN")) {
                localStorage.setItem("origine", "MARQUE_BLANCHE_OHM");
            } else {
                localStorage.setItem("origine", "MARQUE_BLANCHE_COMDATA");
            }
        }

    }
    render() {

        if (this.state.redirect) {
            return <Navigate to={this.state.redirect} />
        }
        if (this.state.successful) {
            return <Navigate to={this.state.nextPage}/>
        }
        return (
            <div className="col-md-12">
                <div className="card card-container">

                    <Form
                        onSubmit={this.handleAction}
                        ref={c => {
                            this.form = c;
                        }}
                    >
                        {!this.state.successful && (
                            <div>
                                <div className="form-group">
                                    <label htmlFor="ct"><b>Référence client</b></label>
                                    <Input
                                        type="text"
                                        className="form-control"
                                        name="cm"
                                        placeholder="Renseigner référence client"
                                        value={this.state.cm}
                                        onChange={this.onChangeCm}
                                        validations={[required, vucm]}
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="origin"><b>Origine</b></label>

                                    {(this.state.roleConnect!=="ROLE_AGENT_EXTERN" || this.state.currentUser.roleConnect!=="ROLE_SUPER_AGENT_EXTERN") && (
                                        <select className="form-control" onChange={this.handleOptionChangeOrigine}>
                                            <option value="MARQUE_BLANCHE_OHM" selected={localStorage.getItem("origine")==="MARQUE_BLANCHE_OHM" ? true : ""} >Marque blanche interne</option>
                                            <option value="ENTRANT_ADM" selected={localStorage.getItem("origine")==="ENTRANT_ADM" ? true : ""} >Entrant ADM</option>
                                            <option value="ENTRANT_MAURICE" selected={localStorage.getItem("origine")==="ENTRANT_MAURICE" ? true : ""}>Entrant Maurice</option>
                                            <option value="CAMPAGNE_DERNIER_APPEL" selected={localStorage.getItem("origine")==="CAMPAGNE_DERNIER_APPEL" ? true : ""} >Campagne dernier appel</option>
                                            <option value="ENTRANT_EUROCRM" selected={localStorage.getItem("origine")==="ENTRANT_EUROCRM" ? true : ""}>Entrant EuroCRM</option>
                                            <option value="ENTRANT_MADA" selected={localStorage.getItem("origine")==="ENTRANT_MADA" ? true : ""}>Entrant Mada</option>
                                            <option value="ENTRANT_AUTRE" selected={localStorage.getItem("origine")==="ENTRANT_AUTRE" ? true : ""}>Entrant Autre</option>
                                        </select>
                                    )}

                                    {(this.state.roleConnect==="ROLE_AGENT_EXTERN" || this.state.currentUser.roleConnect==="ROLE_SUPER_AGENT_EXTERN") && (
                                        <select className="form-control" onChange={this.handleOptionChangeOrigine}>
                                            <option value="MARQUE_BLANCHE_COMDATA" >Marque blanche comdata</option>
                                        </select>
                                    )}


                                </div>



                                <div className="form-group">
                                    <button className="btn-ohm btn btn-primary btn-block">
                                        {(this.state.loading) && (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        )}
                                        <span>Valider</span>
                                    </button>
                                </div>
                            </div>
                        )}

                        {this.state.message && (
                            <div className="form-group">
                                <div
                                    className={
                                        this.state.successful
                                            ? "alert alert-success"
                                            : "alert alert-danger"
                                    }
                                    role="alert"
                                >
                                    {this.state.message}
                                </div>
                            </div>
                        )}
                        <CheckButton
                            style={{ display: "none" }}
                            ref={c => {
                                this.checkBtn = c;
                            }}
                        />
                    </Form>
                </div>
            </div>
        );

    }
}
